<template>
  <AnimatedContainer>
    <header class="flex min-h-screen flex-col-reverse lg:flex-row">
      <Container
        class="flex flex-1 flex-col items-start pt-6 sm:pt-8 lg:pt-32"
        indent="wide"
      >
        <Breadcrumbs class="mb-10 pt-2 sm:mb-6 md:pt-4 lg:pt-14" />

        <h1
          v-if="data.heading"
          class="fade-in mb-10 hyphens-auto text-5xl/10 font-medium md:text-6xl lg:max-w-[28.75rem]"
          v-html="$replaceHtmlTags(data.heading)"
        />

        <ul
          v-if="general.locations && general.locations.length > 0"
          class="flex flex-1 flex-col space-y-6 md:space-y-10"
        >
          <li
            v-for="(location, index) in general.locations"
            :key="index"
            class="fade-in flex items-start"
          >
            <MarkerIcon class="mt-1 w-4 text-blue-800" />

            <div class="flex flex-col items-start pl-4 sm:text-lg">
              <div v-if="location.address" v-html="location.address" />

              <div class="flex text-blue-800">
                <PhoneIcon class="mr-2 w-4" />
                <a
                  v-if="location.phone"
                  :href="`tel:${location.phone}`"
                  class="border-b border-transparent transition hover:border-blue-800"
                >
                  {{ location.phone }}
                </a>
              </div>

              <div class="flex text-blue-800">
                <MailOutlinedIcon class="mr-2 w-4" />
                <a
                  v-if="location.email"
                  :href="`mailto:${location.email}`"
                  class="border-b border-transparent transition hover:border-blue-800"
                >
                  {{ location.email }}
                </a>
              </div>
            </div>
          </li>
        </ul>

        <div class="mb-16 hidden lg:block">
          <Scrolly v-if="data.cta_link_text">
            {{ data.cta_link_text }}
          </Scrolly>
        </div>
      </Container>

      <div class="w-full lg:w-1/2 xl:w-[55%]">
        <AppImage
          v-if="data.hero_image"
          class="h-[65vh] w-full object-cover lg:h-full"
          :src="data.hero_image"
          :alt="
            $i18n.locale === 'fr' ? data.hero_image.alt_fr : data.hero_image.alt
          "
          :style="`object-position: ${data.hero_image.focus_css};`"
        />
      </div>
    </header>
  </AnimatedContainer>
</template>

<script setup>
defineProps({
  data: { type: Object, required: true },
})

const { general } = useGlobalsStore()
const { setIsWhite, setBlackLogo, initWindowResizeWatcher } =
  useNavigationStore()

onMounted(() => {
  initWindowResizeWatcher()
})

onBeforeUnmount(() => {
  setIsWhite(false)
  setBlackLogo(false)
})
</script>
